import styles from "./featured-tournaments.module.css"
import GamesCard from "./GamesCard"

export default function FeaturedTournaments({ tournaments }) {
  return (
    <section className={styles.featuredSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Featured Tournaments</h2>
        <p className={styles.sectionSubtitle}>Join the biggest gaming competitions and win exclusive rewards</p>
      </div>

      {tournaments.length > 0 ?
        (
          <>
            <div className={styles.tournamentsGrid}>
              {tournaments.map((tournament) => (
                <div key={tournament._id}>
                  <GamesCard tournament={tournament} />
                </div>
              ))}
            </div>

            <div className={styles.viewAllContainer}>
              <button className={styles.viewAllBtn}>
                View All Tournaments
                <span className={styles.viewAllArrow}>→</span>
              </button>
            </div>
          </>
        ) :
        (
          <div className={styles.noResults}>
            <p className={styles.noResultsText}>No tournament is available for now.</p>
          </div>
        )}

    </section>
  )
}
